import { styled } from "@mui/material/styles";
import { SwiperSlide } from "swiper/react";

const StyledSwiperSlide = styled(SwiperSlide)(({ theme }) => ({
  "&.swiper-slide": {
    transition: "transform 0.8s ease",
    transform: "scale(0.9) !important",
    "@media (max-width: 450px)": {
      width: "80vw",
    },
    width: 353,
    [theme.breakpoints.up("mobile")]: {
      width: 765,
    },
  },
  "&.swiper-slide-active": {
    transform: "scale(1) !important",
  },
}));

export default StyledSwiperSlide;
